import React from 'react';
import ReactModal from 'react-modal';

import styles from './Header.module.scss';
import modalStyles from '../../../../../../pages/home/Home.module.scss';
import {Grid, Input, Text, Link} from '../../../../../../components';
import Logo from '../../../../../../images/ekipo-logo--blue.svg';

ReactModal.setAppElement('#___gatsby');

const DefaultModal = ({isModalOpen, handleModalClose}) => (
  <ReactModal
    isOpen={isModalOpen}
    onRequestClose={handleModalClose}
    contentLabel="Example Modal In Gatsby"
    className={modalStyles.Modal}
    overlayClassName={modalStyles.ModalOverlay}
  >
    <div className={modalStyles.ModalClose} onClick={handleModalClose} />
    <Text.Container>
      <Text tag="h2" color="var(--color-primary)">
        Join Ekipo now, it's fun!
      </Text>
      <Text>
        Join Ekipo and watch your remote team become closer, happier, and more
        productive! You will be redirected to our dashboard once your email has
        been submitted and verified.
      </Text>
    </Text.Container>
    <form
      name="Sign Up"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
    >
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="form-name" value="Sign Up" />
      <Input
        name="email"
        label="email"
        type="email"
        id="email"
        placeholder="Ex. example@email.com"
        required
      />
      <Text size="small">
        <input required type="radio" name="role" value="founder" />
        <label htmlFor="founder" className={modalStyles.RadioLabel}>
          Founder
        </label>
        <input required type="radio" name="role" value="hr" />
        <label htmlFor="hr" className={modalStyles.RadioLabel}>
          HR
        </label>
        <input required type="radio" name="role" value="developer" />
        <label htmlFor="developer" className={modalStyles.RadioLabel}>
          Developer
        </label>
        <input required type="radio" name="role" value="other" />
        <label htmlFor="other" className={modalStyles.RadioLabel}>
          Other
        </label>
      </Text>

      <button
        type="submit"
        value="submit"
        style={{marginTop: '10px'}}
        className={modalStyles.PricingCtaButton}
      >
        Start Now
      </button>
      <Text size="subscript" italic>
        *No credit cards required, first 60 days are free for the basic plan
      </Text>
    </form>
  </ReactModal>
);

export interface Props {}

type State = {
  isModalOpen: boolean;
};
type ComposedProps = Props;

export default class Header extends React.PureComponent<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  handleModalOpen = () => {
    this.setState({isModalOpen: true});

    if (process.env.NODE_ENV === 'production') {
      // window object does not exist in Webpack's Node environment, this is to prevent the error
      const browserWindow: any = typeof window !== 'undefined' ? window : null;
      browserWindow.ga('send', {
        hitType: 'event',
        eventCategory: 'Sign up modal',
        eventAction: 'open',
        eventLabel: 'CTA Experiment',
      });
    }
  };

  handleModalClose = () => {
    this.setState({isModalOpen: false});

    if (process.env.NODE_ENV === 'production') {
      // window object does not exist in Webpack's Node environment, this is to prevent the error
      const browserWindow: any = typeof window !== 'undefined' ? window : null;
      browserWindow.ga('send', {
        hitType: 'event',
        eventCategory: 'Sign up modal',
        eventAction: 'close',
        eventLabel: 'CTA Experiment',
      });
    }
  };

  render() {
    return (
      <>
        <div className={styles.HeaderSpacer}>
          <div className={styles.HeaderContainer}>
            <Grid>
              <Grid.ScreenWidth>
                <header className={styles.Header}>
                  <Link className={styles.LogoContainer} to="/">
                    <img className={styles.Logo} src={Logo} />
                  </Link>
                  <nav className={styles.Navigation}>
                    <Text size="small">
                      <span
                        onClick={this.handleModalOpen}
                        className={styles.NavigationCta}
                      >
                        Start for free
                      </span>
                    </Text>
                  </nav>
                </header>
              </Grid.ScreenWidth>
            </Grid>
          </div>
        </div>
        <DefaultModal
          isModalOpen={this.state.isModalOpen}
          handleModalClose={this.handleModalClose}
        />
      </>
    );
  }
}
